var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M62.73,14.59a3,3,0,0,0-2.15.91l-4.85,5a26.89,26.89,0,0,0-7.46,0l-4.85-5A3,3,0,0,0,39.76,15L28.23,21.65a3,3,0,0,0-1.38,3.42l1.92,6.72A29.09,29.09,0,0,0,25,38.25l-6.74,1.68A3,3,0,0,0,16,42.84V56.16a3,3,0,0,0,2.27,2.9L25,60.75a29.09,29.09,0,0,0,3.76,6.46l-1.92,6.71a3,3,0,0,0,1.38,3.43L39.76,84a3,3,0,0,0,3.66-.51l4.85-5a25.9,25.9,0,0,0,7.46,0l4.85,5a3,3,0,0,0,3.65.51l11.53-6.65a3,3,0,0,0,1.39-3.43l-1.93-6.71A29.13,29.13,0,0,0,79,60.75l6.73-1.69A3,3,0,0,0,88,56.16V42.84a3,3,0,0,0-2.28-2.91L79,38.25a29.52,29.52,0,0,0-3.77-6.46l1.93-6.72a3,3,0,0,0-1.39-3.42L64.23,15A3,3,0,0,0,62.73,14.59ZM63,19.47,72.5,25l-1.6,5.59-.62,2.18,1.37,1.79A24.64,24.64,0,0,1,74.83,40l.87,2.08,2.19.55L83.5,44V55l-5.61,1.41-2.19.55L74.83,59a24.36,24.36,0,0,1-3.18,5.45l-1.37,1.8.62,2.17L72.5,74,63,79.52l-4-4.17-1.57-1.62L55.15,74a23.69,23.69,0,0,1-3.15.23A23.94,23.94,0,0,1,48.84,74l-2.24-.28L45,75.35l-4,4.17L31.5,74l1.6-5.6.62-2.17-1.38-1.8A24.75,24.75,0,0,1,29.16,59l-.87-2.09-2.19-.54L20.5,55V44l5.6-1.4,2.19-.55L29.16,40a25,25,0,0,1,3.18-5.46l1.38-1.79-.62-2.18L31.5,25,41,19.48l4,4.17,1.56,1.62L48.84,25A23.94,23.94,0,0,1,52,24.76a23.69,23.69,0,0,1,3.15.23l2.24.28L59,23.65ZM52,60.75A11.25,11.25,0,1,1,63.25,49.5,11.26,11.26,0,0,1,52,60.75Zm0-18a6.75,6.75,0,1,0,6.75,6.75A6.76,6.76,0,0,0,52,42.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.12112776cc9f294dc7cd582167b6c76c.svg";
export { ForwardRef as ReactComponent };